"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z
        .string()
        .describe('Artifact slug.  The artifact slug will become part of the table name.  Once created, the artifact should not be changed.  If it is changed, a new table will be created, and any previous data will be associated with the old table. The resulting table name with be custom_tapes_<implementation_slug>_<artifactSlug> (in snake_case)'),
});
exports.nodeType = 'file_uploadToDatalake';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'uploadToDatalake';
//# sourceMappingURL=types.js.map